/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_IntegerInputs */

const en_enum_setting_data_type_integer = /** @type {(inputs: Enum_Setting_Data_Type_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type Integer`)
};

const de_enum_setting_data_type_integer = /** @type {(inputs: Enum_Setting_Data_Type_IntegerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ Integer`)
};

/**
* | output |
* | --- |
* | "Data Type Integer" |
*
* @param {Enum_Setting_Data_Type_IntegerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_integer = /** @type {((inputs?: Enum_Setting_Data_Type_IntegerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_IntegerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_integer(inputs)
	return de_enum_setting_data_type_integer(inputs)
});